<template lang="pug">
   Modal(ref="dlg" title="Select Location" closeable="true")
    .location-tree-modal
      LocationsTree(v-model="geoLocation")
</template>

<script>
import Modal from '@/components/common/Modal'
import LocationsTree from '@/components/common/LocationsTree'

export default {
  props: ['value'],
  data() {
    return {
      geoLocation: null
    }
  },
  methods: {
    open() {
      this.$refs.dlg.open()
    }
  },
  watch: {
    geoLocation() {
      this.$emit('setGeoLocation', this.geoLocation)
    }
  },
  components: {
    Modal,
    LocationsTree
  }
}
</script>

<style lang="scss">
.location-tree-modal {
  width: 500px;
  overflow: auto;
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/ssp/LocationTreeModal.vue